import {
  Action,
  ActionType,
  DepartmentListBusinessResponse,
} from "models/userListBusiness/departmentList";
import createReducer from "../../createReducer";

export interface DepartmentsListReducerType {
  loading: boolean;
  error?: string;
  departmentsListResponse?: DepartmentListBusinessResponse;
}

const defaultState: DepartmentsListReducerType = {
  loading: false,
  error: undefined,
  departmentsListResponse: undefined,
};

export const departmentsListReducer = createReducer<DepartmentsListReducerType>(
  defaultState,
  {
    [ActionType.DEPARTMENT_LIST_BUSINESS](state: DepartmentsListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DEPARTMENT_LIST_BUSINESS_ERROR](
      state: DepartmentsListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        departmentsListResponse: undefined,
      };
    },

    [ActionType.DEPARTMENT_LIST_BUSINESS_SUCCESS](
      state: DepartmentsListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        departmentsListResponse: action.payload,
      };
    },

    [ActionType.DEPARTMENT_LIST_BUSINESS_RESET_DATA](
      state: DepartmentsListReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        departmentsListResponse: undefined,
      };
    },
  }
);
